/// <reference path="../../../WebUI/typings/tsd.d.ts" />
import * as React from "react";
import * as ReactDOM from "react-dom";
import {DialogBase} from "./DialogBase";

export class GenericDialog<P> extends DialogBase {
    private options: GenericDialogOptions;
    protected panel: React.Component<P, any>;

    constructor(private componentClass: React.ComponentClass<P>, private props: P, options?: GenericDialogOptions) {
        super();
        this.options = $.extend({}, DefaultGenericDialogOptions, options || {});
        if (this.options.dialogClass) {
            this.$el.addClass(this.options.dialogClass);
        }
    }

    protected render(): void {
        let element = React.createElement(this.componentClass, this.props);
        this.panel = ReactDOM.render(element, this.$el[0], () => {
            this.init();
        });
    }

    protected init(): void {
        // Call base class method to complete initialization.
        super.init();
    }

    protected handleEvents(): void {
        super.handleEvents();
        this.$el.on('click', '.dialog-close-button', () => {
            this.onCancel();
        });
    }
}

export interface GenericDialogOptions {
    dialogClass?: string;
}

var DefaultGenericDialogOptions: GenericDialogOptions = {
};



// WEBPACK FOOTER //
// ./Client/Dialogs/GenericDialog.ts